// extracted by mini-css-extract-plugin
export default {"list":"List_list__uPAJ4","active":"List_active__dlMQJ"};